import { APIcallerv2 } from './APIcaller';

const getSupplierProductsAndRecipesByStoreId = (storeId, date) =>
  APIcallerv2.apiGet(`/transfers/store/${storeId}/supplier-products-recipes?date=${date}`);

const getTransferListById = (transferListId) =>
  APIcallerv2.apiGet(`/transfers/${transferListId}/details`);

const createTransfer = ({ transferList, supplierProducts, recipes }) =>
  APIcallerv2.apiPost('/transfers/create', { transferList, supplierProducts, recipes });

const updateTransferDeliveryNote = ({ transferList, supplierProducts, recipes }) =>
  APIcallerv2.apiPost('/transfers/delivery-note', { transferList, supplierProducts, recipes });

const updateTransferReception = ({ transferList, supplierProducts, recipes }) =>
  APIcallerv2.apiPost('/transfers/reception', { transferList, supplierProducts, recipes });

export default {
  getSupplierProductsAndRecipesByStoreId,
  getTransferListById,
  createTransfer,
  updateTransferDeliveryNote,
  updateTransferReception,
};
